import { actionTypes } from '../actions/idx_admin_doc_qual.ac'

const initialState = {
  error: null,
  docQuals: null,
  isFetching: false
}

export const idxAdminDocQual = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCHING_IDX_ADMIN_DOC_QUALS:
      return {
        ...state,
        isFetching: true
      }

    case actionTypes.RECEIVED_IDX_ADMIN_DOC_QUALS:
      return {
        ...state,
        error: null,
        isFetching: false,
        docQuals: action.data
      }

    case actionTypes.SET_IDX_ADMIN_DOC_QUALS:
      return {
        ...state,
        docQuals: action.data
      }

    case actionTypes.FAILED_FETCHING_IDX_ADMIN_DOC_QUALS:
      return {
        ...state,
        error: true,
        docQuals: null,
        isFetching: false
      }

    default:
      return state
  }
}
